import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import api from '../../../../providers/api';
import useIsAr from '../../../../Hooks/useIsAr';
import { ReactComponent as ArrowIcon } from '../../../../assets/images/sub-arrow.svg';
import { REQUEST_STATUSES } from '../../../../configs/enums';
import Table from '../../../NewTable';
import {
  addToast,
  formatDate,
  getUnitOfMeasure,
  getStatusKPIName
} from '../../../../helpers';

function KPIHistory({ measureItem, onBack }) {
  const [isAr, locale] = useIsAr();
  const [loading, setLoading] = useState(true);
  const [request, setRequest] = useState({});
  const requestStatuses = useSelector(
    ({ theme }) => theme.WorkflowStatus.item.Items
  );

  const fetchData = async () => {
    setLoading(true);
    try {
      const { Data: requestData } = await api.workflow.getByID(measureItem?.ID);
      setRequest(requestData);
    } catch (error) {
      addToast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  function getStyle(status) {
    if (status === REQUEST_STATUSES.SUBMITTED) return 'is-active';
    if (status === REQUEST_STATUSES.APPROVED) return 'is-active';
    if (status === REQUEST_STATUSES.PENDING) return 'is-pending';
    if (status === REQUEST_STATUSES.REJECTED) return 'rejected';
    return '';
  }

  const columns = [
    {
      key: 'name',
      header: <FormattedMessage id="kpi-histoy.name" />,
      cell: (item) => item.ActionByModel?.DisplayName || '--',
      width: '20%'
    },
    {
      key: 'action',
      header: <FormattedMessage id="kpi-histoy.action" />,
      cell: (item) =>
        item.Status === REQUEST_STATUSES.SUBMITTED ? (
          <span>
            <FormattedMessage id="common.update-kpi-value" />
            <FormattedMessage id="common.from" /> {request.Form?.OldValue}
            {getUnitOfMeasure(request.UnitOfMeasure)}
            <FormattedMessage id="common.to" /> {request.Form?.Value}
            {getUnitOfMeasure(request.UnitOfMeasure)}
          </span>
        ) : (
          `${getStatusKPIName(
            requestStatuses,
            item.Status?.toString(),
            locale
          )} (${isAr ? item.ArabicName : item.EnglishName})`
        ),
      width: '30%'
    },
    {
      key: 'data',
      header: <FormattedMessage id="common.action-date" />,
      cell: (item) => formatDate(item.Modified),
      width: '15%'
    },
    {
      key: 'comment',
      header: <FormattedMessage id="kpi-histoy.comment" />,
      cell: 'Comments',
      width: '35%'
    }
  ];

  if (loading) return null;

  return (
    <div className="kpi-history" style={{ margin: '0 32px' }}>
      <div className="tb-cont">
        {onBack && (
          <div
            className={`back-btn ${!isAr && 'ltr'}`}
            onClick={() => onBack()}
          >
            <ArrowIcon fill={'var(--primary-color)'} />{' '}
            <FormattedMessage id="back" />
          </div>
        )}

        <div id="timeline_1">
          <ul className="list-unstyled multi-steps">
            {request.Steps.length > 0 ? (
              <>
                {request.Steps.map((item, i) => (
                  <li
                    className={`${getStyle(item.Status)} ${locale}`}
                    key={item.ID}
                  >
                    {isAr ? item.ArabicName : item.EnglishName}
                  </li>
                ))}
              </>
            ) : null}
          </ul>
        </div>
        <Table columns={columns} data={request.Steps} />
      </div>
    </div>
  );
}

export default KPIHistory;
